import request from '@/utils/request'

/** 订单工作台总览（账单状态卡 + 退款状态卡 + 业绩概况） */
export function orderConsole(data) {
  return request.post('/stats/console', data)
}

/** 业绩统计（LEVEL: staff/unit/team + 部门/员工筛选） */
export function statsPerform(params) {
  return request.get('/stats/perform', { params })
}

/** 入量趋势（按日线索量，可按 unit_id/team_id/staff_id 筛选） */
export function statsLeadTrend(params) {
  return request.get('/stats/leadTrend', { params })
}

/** 推广统计（按录入人聚合，可按 unit_id/team_id/staff_id 筛选） */
export function statsPromo(params) {
  return request.get('/stats/promo', { params })
}

/** 数据分析：重复推分析（同一量账号被 ≥2 位运营录入；keyword 搜索 + page/limit 分页） */
export function statsDuplicate(params) {
  return request.get('/stats/duplicate', { params })
}

/** 数据分析：渠道来源分布（占比/有效vs重复堆叠/TOP5 每日趋势） */
export function statsChannel(params) {
  return request.get('/stats/channelAnalysis', { params })
}

/** 数据分析：订单分析（账龄/金额/回款分布 + 催收重点；warn=1 仅看账龄≥90天未收清） */
export function statsOrder(params) {
  return request.get('/stats/orderAnalysis', { params })
}

/** 数据分析：员工效能（漏斗 + 运营效能排行 + 销售产出排行） */
export function statsEfficiency(params) {
  return request.get('/stats/efficiency', { params })
}
